import { http } from '@/api/http';
import { PaginatedApiResponseBody, PaginationSearchParams } from '@/api/types';
import { TrialProgram } from './trial-programs.types';
import { getTrialProgramsApiUrl } from './trial-programs.paths';

const getTrialProgramsList = async (params: PaginationSearchParams) => {
  const res = await http.get<PaginatedApiResponseBody<TrialProgram>>(getTrialProgramsApiUrl.list(), { params });
  return res.data.data;
};

export const trialsApiFetchers = {
  getTrialProgramsList,
};
